import QuoteModalWrapper from "../Quotes/QuoteCreationModal/QuoteModalWrapper";

export default function NewQuoteModal() {
  return (
    <div className="px-5">
      <QuoteModalWrapper />
    </div>
  );
}
